import { render, staticRenderFns } from "./IpsAlert.vue?vue&type=template&id=f785feaa&scoped=true"
import script from "./IpsAlert.vue?vue&type=script&lang=js"
export * from "./IpsAlert.vue?vue&type=script&lang=js"
import style0 from "./IpsAlert.vue?vue&type=style&index=0&id=f785feaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f785feaa",
  null
  
)

export default component.exports